import { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";

import DocumentTypeTiles from "../components/DocumentTypeTiles.jsx";
import RecentDocumentsCard from "../components/RecentDocumentsCard.jsx";
import SparteSummaryCard from "../components/SparteSummaryCard.jsx";
import PortalContractsTable from "../components/PortalContractsTable.jsx";
import GlobalSearch from "../components/GlobalSearch.jsx";

/**
 * The Kundenportal's dashboard: document-type tiles, the Sparte card
 * and the updates card next to it, plus the same contract table /vertraege uses
 * (PortalContractsTable, KP-07), with a card header title so its total shows
 * there in addition to the table's own pager.
 */
export default function DashboardPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([{ name: "Übersicht", path: "/" }]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Meine Übersicht
      </Typography>
      <GlobalSearch />
      <DocumentTypeTiles />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1.1fr 1fr" },
          columnGap: 3,
          alignItems: "start",
        }}
      >
        <SparteSummaryCard />
        <RecentDocumentsCard />
      </Box>
      <PortalContractsTable title="Verträge" />
    </Box>
  );
}
